import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query SpaceJobTitles(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                jobTitles {
                  id
                  name
                  code
                  description
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceJobTitlesQuery,
    ents.extra.space.JobTitle[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'jobTitles',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    code: transformers.PASS_THROUGH,
                    description: transformers.PASS_THROUGH,
                    id: graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.extra.space.Employee.Id.isId,
                    ),
                    name: transformers.PASS_THROUGH,
                  }),
                  {
                    onNullish: 'remove',
                  },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceJobTitlesQuery,
  ents.extra.space.JobTitle[],
  graphql.schema.SpaceJobTitlesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
